/**
 * @generated SignedSource<<6be9e6ac7c31deecebc7b254ac55ce0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderEditFlightTicketDeleteMutation$variables = {
  id: string;
};
export type OrderEditFlightTicketDeleteMutation$data = {
  readonly deleteOrderFlightTicket: {
    readonly flightTicket: {
      readonly " $fragmentSpreads": FragmentRefs<"StoredFile_file">;
    } | null;
  };
};
export type OrderEditFlightTicketDeleteMutation = {
  response: OrderEditFlightTicketDeleteMutation$data;
  variables: OrderEditFlightTicketDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OrderEditFlightTicketDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "deleteOrderFlightTicket",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StoredFile",
            "kind": "LinkedField",
            "name": "flightTicket",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StoredFile_file"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrderEditFlightTicketDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "deleteOrderFlightTicket",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StoredFile",
            "kind": "LinkedField",
            "name": "flightTicket",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fileName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "size",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0adbad7aae7b72d7b4a340f036f567b7",
    "id": null,
    "metadata": {},
    "name": "OrderEditFlightTicketDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation OrderEditFlightTicketDeleteMutation(\n  $id: ID!\n) {\n  deleteOrderFlightTicket(id: $id) {\n    flightTicket {\n      ...StoredFile_file\n      id\n    }\n    id\n  }\n}\n\nfragment StoredFile_file on StoredFile {\n  fileName\n  size\n}\n"
  }
};
})();

(node as any).hash = "7aee290ebc8f6307334edc5fbf206c04";

export default node;
